
import Navbar from "./Component/Navbar/navbar";
import AllRoutes from './Component/AllRoutes/AllRoutes';
import Footer from './Component/Footer/Footer';
// import SignInForm from "./Component/Pages/SignUp";



function App() {
  return (
    <div className="App">
      <Navbar />
      <AllRoutes />
      <Footer />
    </div>
  );
}

export default App;
